import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSTATUSREASONSTableStructure";
export const UPDATE_TABLE_DATA = "getSTATUSREASONSTableData";
export const EXPORT_TABLE_DATA = "exportSTATUSREASONSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSTATUSREASONSTableStructure";
export const SET_TABLE_DATA = "setSTATUSREASONSTableData";
export const SET_TABLE_FILTER = "setSTATUSREASONSTableFilter";
export const SET_TABLE_PAGE = "setSTATUSREASONSTablePage";
export const SET_TABLE_PERPAGE = "setSTATUSREASONSTablePerPage";
export const SET_TABLE_SORTBY = "setSTATUSREASONSTableSortBy";
export const SET_TABLE_SORTORDER = "setSTATUSREASONSTableSortOrder";
export const SET_EXPORT_LINK = "setSTATUSREASONSExportLink";
export const SET_TABLE_PER_PAGE = "setSTATUSREASONSTablePerPage";
export const SET_TABLE_SORT_BY = "setSTATUSREASONSTableSortBy";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getSTATUSREASONSTableProperties(state) {
    return state.table_structure.properties;
  },
  getSTATUSREASONSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSTATUSREASONSTableState(state) {
    return state.table_state;
  },

  getSTATUSREASONSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSTATUSREASONSTableFilters(state) {
    return state.table_structure.filters;
  },

  getSTATUSREASONSTableData(state) {
    return state.table_data.data;
  },

  getSTATUSREASONSExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/order_management/status_reasons")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/order_management/status_reasons/datatable", payload)
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/status_reasons/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
